/**
 * Holds the last real slide selection so the Animations pane keeps pointing at an object.
 *
 * Shape and WordArt drop their selection on blur (Shape.js handleBlur, WordArt handleBlur),
 * so moving focus into the pane — or into a <select> inside it — deselects the very object
 * being edited. Holding the last real selection keeps the pane pointed at that object until
 * the user picks a different one, which is also how PowerPoint behaves.
 *
 * Reset happens by unmounting: the pane only renders while it is open, so reopening it
 * starts from the live selection again.
 */

import { useEffect, useState } from 'react';

export const useStickySelection = (selected) => {
  const [sticky, setSticky] = useState(selected || null);

  useEffect(() => {
    if (selected) setSticky(selected);
  }, [selected]);

  return selected || sticky;
};

export default useStickySelection;
